<a class="logo" routerLink="/cashier">
  @if (!isCollapsed) {
    <img class="logo-icon" src="/assets/images/logo.svg" />
  }
  @if (isCollapsed) {
    <img
      class="logo-icon"
      src="/assets/images/logo-mini.svg"
      />
  }
</a>
<ul nz-menu nzTheme="light" nzMode="inline">
  <li nz-submenu nzTitle="User" nzIcon="user">
    <ul>
      <li nz-menu-item>Tom</li>
      <li nz-menu-item>Bill</li>
      <li nz-menu-item>Alex</li>
    </ul>
  </li>
  <li nz-submenu nzTitle="Team" nzIcon="team">
    <ul>
      <li nz-menu-item>Team 1</li>
      <li nz-menu-item>Team 2</li>
    </ul>
  </li>
  <li nz-menu-item>
    <i nz-icon nzType="file"></i>
    <span>File</span>
  </li>
</ul>
